<template>
    <div v-if="loaded">
        <InputDetail
                class="datePickerInput"
                label="Laufzeit"
                placeholder="TT.MM.JJ (bis TT.MM.JJ)"
                icon="icon-calendar"
                :value="dateString"
                :iconBorder="true"
                :disabled="true"
                icon-size="1.8em"
                @click="openCalendar"
        ></InputDetail>
        <Dialog :has-backdrop="true" :show="showPicker" @close="closeCalendar">
            <div>
                <h4>Laufzeit hinzufügen und bestätigen</h4>
                <v-date-picker style="border: none"
                               mode="range"
                               color="gray"
                               is-inline
                               :columns="2"
                               v-model="range"
                />
                <AdaButton @click="saveClicked" title="AUSWAHL BESTÄTIGEN" type="createButton"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "./Dialog";
    import InputDetail from "./InputDetail";
    import AdaButton from "./AdaButton";

    export default {
        components: {
            AdaButton,
            Dialog,
            InputDetail
        },
        data() {
            return {
                showPicker: false,
                dateString: '',
                range: {
                    start: {},
                    end: {}
                },
                loaded: false
            }
        },
        props: {
            date_start: {
                required: true
            },
            date_end: {
                required: true
            }
        },
        mounted() {
            this.range = {
                start: this.date_start,
                end: this.date_end
            };
            if (typeof this.date_start !== 'undefined' && typeof this.date_end !== 'undefined' && this.date_start !== '' && this.date_end !== '') {
                this.setDateString();
            }
            this.loaded = true;
        },
        methods: {
            closeCalendar: function () {
                this.$emit('close', this.range);
                this.showPicker = false;
            },
            openCalendar: function () {
                this.showPicker = true;
            },
            saveClicked: function () {
                if (this.range.start instanceof Date && this.range.end instanceof Date) {
                    this.setDateString();
                }
                this.closeCalendar();
            },
            setDateString() {
                this.dateString = this.formatDate(this.range.start) + ' - ' + this.formatDate(this.range.end);
            },
            formatDate: function (date) {
                if(!date) {
                    return '';
                }
                if(typeof date === 'string') {
                    date = new Date(date);
                }
                let day = date.getDate() + '';
                let month = (date.getMonth() + 1) + '';
                let year = date.getFullYear() + '';
                year = year.substring(2, 4);
                if (day.length === 1) {
                    day = '0' + day;
                }
                if (month.length === 1) {
                    month = '0' + month;
                }
                return day + '.' + month + '.' + year;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .datePickerInput.inputContainer {
        margin-bottom: 0px;
    }

</style>